(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-slider-slide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Splide('[data-logo-bar-slider]', {
      arrows: false,
      pagination: false,
      type: 'loop',
      drag: 'free',
      perPage: 3,
      flickPower: 100,
      autoScroll: {
        speed: 0.66,
      },
    }).mount(window.splide.Extensions);
  });

  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('[data-logo-modal-button]');
    const modal = document.querySelector('[data-logo-modal]');
    const modalImage = document.querySelector('[data-logo-modal-image]');
    const overlay = document.querySelector('[data-logo-modal-overlay]');

    if (modal && modalImage && overlay) {
      buttons.forEach((button) => {
        if (button.getAttribute('data-logo-modal-enabled') === 'false') {
          button.disabled = true;
        } else {
          button.addEventListener('click', () => {
            modal.style.display = 'block';
            overlay.style.display = 'block';

            modalImage.src = button.getAttribute('data-logo-modal-image-url');
            modalImage.alt = button.getAttribute('data-logo-modal-alt');
          });
        }
      });

      overlay.addEventListener('click', () => {
        modal.style.display = 'none';
        overlay.style.display = 'none';
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
